import * as _ from "lodash";
import { UNIFIED_API_SEARCH_ISOLATIONGROUP_FILTER, UNIFIED_API_SEARCH_ISOLATIONGROUP_EXPAND } from "./ExpAPIVUnified.constants.js";
import moment from "moment-timezone";
import { getExperimentationGroupIdFromPath } from "../../utils/ManagementGroup/ManagementGroup.utils.js";
const getDateWithTimezone = (dateString) => {
  return moment.utc(dateString).tz("America/Los_Angeles").format();
};
const getFormattedDateTime = (value) => {
  const dateMoment = value ? moment(value) : void 0;
  const dateFormatted = (dateMoment == null ? void 0 : dateMoment.isValid()) ? dateMoment.format("MM/DD/YYYY") : void 0;
  return dateFormatted;
};
const getIsolationGroupSearchQuery = (isolationGroups) => {
  if (!Array.isArray(isolationGroups)) {
    return "";
  }
  if (!isolationGroups || isolationGroups.length === 0) {
    return "";
  }
  if (isolationGroups.length === 1) {
    return UNIFIED_API_SEARCH_ISOLATIONGROUP_FILTER(`eq '${isolationGroups}'`);
  }
  return UNIFIED_API_SEARCH_ISOLATIONGROUP_FILTER(`in ['${_.join(isolationGroups, "','")}']`);
};
const buildFilterString = (workspaceId, filters) => {
  if (!filters) {
    return null;
  }
  const otherSystemQueryOptions = [];
  const filterSystemQueryOptions = [];
  const expandSystemQueryOptions = [];
  if (filters.fromDateTime && filters.toDateTime) {
    filterSystemQueryOptions.push(
      `Experiments/any(e: e/ExperimentSteps/any(s: s/StartedAt ge ${getDateWithTimezone(
        filters.fromDateTime
      )} and s/StartedAt le ${getDateWithTimezone(filters.toDateTime)}))`
    );
  } else if (filters.fromDateTime) {
    filterSystemQueryOptions.push(
      `Experiments/any(e: e/ExperimentSteps/any(s: s/StartedAt ge ${getDateWithTimezone(filters.fromDateTime)}))`
    );
  } else if (filters.toDateTime) {
    filterSystemQueryOptions.push(
      `Experiments/any(e: e/ExperimentSteps/any(s: s/StartedAt le ${getDateWithTimezone(filters.toDateTime)}))`
    );
  }
  _.each(filters, (value, key) => {
    if (_.includes(["top", "skip", "orderBy", "collapseRolloutTargetsIntoRoot", "onlyLoadFeatureData"], key)) {
      otherSystemQueryOptions.push(`${key}=${value}`);
    } else if (_.includes(["fromDateTime", "toDateTime"], key)) {
    } else if (value !== null && value !== void 0) {
      if (key === "isArchived") {
        filterSystemQueryOptions.push(`IsArchived eq ${value}`);
      } else if (key === "keywordSearch") {
        filterSystemQueryOptions.push(
          `(contains(Feature/Name, '${value}') or contains(Feature/Description, '${value}') or Feature/FeatureVariants/any(f: contains(f/Variant/DisplayName, '${value}') or contains(f/Variant/Payload/Payload, '${value}')))`
        );
      } else if (key === "experimentationGroup") {
        if (_.isArray(value)) {
          var values = _.map(value, (val) => `'${getExperimentationGroupIdFromPath(workspaceId, val)}'`);
          filterSystemQueryOptions.push(`ExperimentationGroup in [${values.join(",")}]`);
        } else {
          value = getExperimentationGroupIdFromPath(workspaceId, value.toString());
          filterSystemQueryOptions.push(`(ExperimentationGroup eq '${value}' or startswith(ExperimentationGroup, '${value}~'))`);
        }
      } else if (key === "subscriber") {
        filterSystemQueryOptions.push(`subscriber eq '${value}'`);
      } else if (key === "isolationGroups") {
        if (Array.isArray(value) && value.length > 0 && value[0] !== "") {
          filterSystemQueryOptions.push(getIsolationGroupSearchQuery(value));
          expandSystemQueryOptions.push(UNIFIED_API_SEARCH_ISOLATIONGROUP_EXPAND);
        }
      } else if (key === "status") {
        let statusQueryString = "";
        if (!_.isArray(value)) {
          statusQueryString = getStatusQueryString(value);
        } else if (!_.isEmpty(value)) {
          statusQueryString = `(${_.map(value, (v) => getStatusQueryString(v)).filter((v) => !!v).join(" or ")})`;
        }
        if (!!statusQueryString) {
          filterSystemQueryOptions.push(statusQueryString);
        }
      } else {
        throw `key '${key}' not supported`;
      }
    }
  });
  const parts = [];
  otherSystemQueryOptions.length && parts.push(otherSystemQueryOptions.join("&"));
  filterSystemQueryOptions.length && parts.push(`filter=${filterSystemQueryOptions.join(" and ")}`);
  expandSystemQueryOptions.length && parts.push(`expand=${expandSystemQueryOptions.join(",")}`);
  return parts.join("&");
};
const getStatusQueryString = (status) => {
  if (status === "new") {
    return `Experiments/all(e: e/ExperimentSteps/all(s: s/StartedAt eq null and s/StoppedAt eq null))`;
  } else if (status === "running") {
    return `Experiments/any(e: e/ExperimentSteps/any(s: s/StartedAt ne null and s/StoppedAt eq null))`;
  } else if (status === "completed" || status === "stopped") {
    return `Experiments/any(e: e/ExperimentSteps/any(s: s/StartedAt ne null and s/StoppedAt ne null)) and Experiments/all(e: e/ExperimentSteps/all(s: s/StartedAt eq null or s/StoppedAt ne null))`;
  }
  return "";
};
export {
  buildFilterString,
  getDateWithTimezone,
  getFormattedDateTime,
  getIsolationGroupSearchQuery,
  getStatusQueryString
};
//# sourceMappingURL=ExpApiVUnified.utils.js.map
